import { AlphaUBoxIcon } from './AlphaUBoxIcon';

/**
 * author: GreenTurtwig
 * id B383312A-D001-4F27-95D9-9C705B7529E7
 * name alpha-u-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-u-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterUBoxIcon = AlphaUBoxIcon;
export default LetterUBoxIcon